<template>
  <div class="buy">
    <!-- <div class="buy-top">
       <img src="@/assets/imgs/recharge/desc.png" class="desc"/>
       <div class="card">
         <img src="@/assets/imgs/recharge/medal.png" class="medal"/>
         <div class="content">
           <div class="line">
             <p class="name">{{detail.vipName}}</p>
             <p class="price"><span>¥</span>{{priceYuan(detail.discountsPrice)}}</p>
           </div>
           <div class="line">
             <p class="name">购买规格：{{detail.dayType}}</p>
             <p class="price">原价 ¥{{priceYuan(detail.originalPrice)}}</p>
           </div>
         </div>
       </div>
    </div> -->
    <div class="buy-bottom">
          <van-cell-group class="buy-member buy-member-bold">
      <van-cell title="订单价格">
        <template #right-icon>
          <span class="members-price">￥{{ (lvkeyunData.price) }}</span>
        </template>
      </van-cell>
    </van-cell-group>
    <!-- <h4>请选择支付方式</h4> -->
    <van-cell-group class="buy-member" :border="false">
      <van-cell title="订单价格">
        <template #title>
          <img src="@/assets/imgs/members/wx.png" alt="微信" />
          <span class="custom-title">微信支付</span>
					<!-- <span>(微信还需支付{{ wxMoney }}元)</span> -->
        </template>
        <template #right-icon>
          <div>
            <img
              src="@/assets/imgs/services/buy-checked.png"
              alt="选中"
            />
            <!-- <img v-else src="@/assets/imgs/services/uncheck.png" alt="未选中" /> -->
          </div>
        </template>
      </van-cell>
    </van-cell-group>
    <div class="flex service">
      <div @click="selectService">
        <img v-if="isAgree" src="@/assets/imgs/members/xz.png" alt="未选中" />
        <img v-else src="@/assets/imgs/members/uncheck.png" alt="选中" />
      </div>
      <span>支付即代表同意 <a :href="protocols.lawyer_value_added_service_protocol">《增值服务购买协议》</a></span>
    </div>
    </div>
    <div class="footer tc">
      <button @click="pay">立即支付</button>
    </div>
  </div>
</template>

<script>
import {protocols} from "@/libs/config";
import { priceYuan } from "@/libs/tool";
import {orderLkyPay} from "@a/lvkeyun";
// import { callApp } from "@/libs/bridge";
export default {
  name: "bug",
  data() {
    return {
			priceYuan,
      protocols,
      lvkeyunData:{
        orderId:this.$basicsTools.getQueryUrl('orderId'),
        price:this.$basicsTools.getQueryUrl('price'),
      },
      /**协议同意 */
      isAgree: false,
    };
  },
  mounted(){
    this.init()
  },
  components: {
    
  },
	watch: {
	},
  methods: {
		init(){
      let obj = {
        orderId:this.$basicsTools.getQueryUrl('orderId'),
        price:this.$basicsTools.getQueryUrl('price'),
      }
      localStorage.setItem('lvkeyunData',JSON.stringify(obj))
		},
    selectService() {
      this.isAgree = !this.isAgree;
    },
    pay(){
      if(!this.isAgree){
        this.$toast('请同意增值服务购买协议')
        return false
      }
      const a = this.$toast.loading('加载中')
      orderLkyPay({
          orderId:this.lvkeyunData.orderId,
          payType:2
      }).then(({data})=>{
        const payResultMsg = JSON.parse(data.payResultMsg)
        window.location.href = payResultMsg.h5_url
        a.clear()
        return data
      }).catch(()=>{
        a.clear()
      })
    }
  },
};
</script>

<style lang="scss" scoped>
.buy {
  height: 100vh;
  color: #46474b;
}
.buy-top {
  width: 375px;
  background: linear-gradient(53deg, #131B62 16%, #5F6BCD 100%);
  text-align: center;
  padding-top: 8px;
  .desc{
    width: 242px;
    height: 59px;
  }
  .card{
    width: 343px;
    background: url("../../assets/imgs/recharge/card.png") no-repeat;
    background-size: 100% 100%;
    margin: 16px 16px 0 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px 24px;
    box-sizing: border-box;
    .medal{
      width: 72px;
      height: 72px;
    }
    .content{
      flex: 1;
      margin-left: 8px;
      height: 72px;
      padding: 11px 0;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .line{
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 18px;
        font-weight: 600;
        color: #7E2B03;
        .price span{
          font-size: 13px;
          font-weight: normal;
        }
        &:last-child{
          font-size: 13px;
          font-weight: normal;
          .price{
            color: #B97E23;
            text-decoration: line-through;
          }
        }
      }
    }
  }
}
.buy-bottom{
  margin-top: -10px;
}
.buy-member-bold {
  background: transparent;
  .van-cell {
    border-radius: 15px 15px 0 0 !important;
    font-weight: 600;
    color: #333333 !important;
    font-size: 17px !important;
  }
  .van-hairline--top-bottom::after,.van-hairline-unset--top-bottom::after{
    border-width: 0px !important;
  }
}
.buy-member {
  .van-cell {
    color: #46474b !important ;
  }
  .members-price {
    color: #4a549e;
    font-size: 17px;
    font-weight: 600;
  }

  img {
    width: 18px;
    height: 18px;
    vertical-align: middle;
    margin-right: 5px;
  }

  label {
    color: #4a549e;
    font-weight: 600;
  }
}
.service {
  padding: 16px;
  img {
    width: 15px;
    height: 15px;
    vertical-align: middle;
    position: relative;
    top: 2px;
    margin-right: 5px;
  }
  a {
    color: #d4b37d;
  }
}
.count-down{
  width: 100%;
  font-weight: 500;
  color: #46474B;
  font-size: 14px;
  display: flex;
  justify-content: center;
  position: fixed;
  bottom: 80px;
  ::v-deep p{
    color: #F34747;
    font-size: 17px;
  }
}
.footer {
  position: fixed;
  bottom: 20px;
  width: 100%;

  button {
    width: 90%;
    line-height: 40px;
    background: #4a549e;
    color: #ffffff;
    font-size: 15px;
    outline: none;
    border: none;
    border-radius: 44px;
  }
}
.van-nav-bar .van-icon{
	color: #000 !important;
}
</style>
